export const useSanityPath = (props) => {
  const { _type, main, slug } = props || {};

  function getPath(_type, slug, main) {
    // const productSlug = (main && main.slug) || {};
    switch (_type) {
      case 'aboutPage':
        return `/${slug.current}`;
      case 'service':
        return `/${slug.current}`;
      case 'healthSafetyPage':
        return `/healthAndSafety`;
      case 'sustainabilityPage':
        return `/sustainability`;
      case 'careersHome':
        return `/careers`;
      case 'projectsHome':
        return `/projects`;
      case 'projects':
        return `/projects/${slug.current}`;
      case 'newsHome':
        return `/news`;
      case 'contactPage':
        return `/contact`;
      case 'homePage':
        return `/`;
      default:
        return null;
    }
  }

  const path = getPath(_type, slug, main);

  return path;
};
